// Hook personalizado para enviar mensajes.
// Usa useMutation de TanStack para operaciones de escritura.
// El servicio ya maneja la invalidación de cache automáticamente.
// Adaptado para web desde amarsi-app.

import { useMutation } from '@tanstack/react-query';
import { chatService } from '../../services/chatService';

// Constante para controlar logs de desarrollo
const DEBUG = process.env.NODE_ENV === 'development';

export function useSendMessage() {
  return useMutation({
    mutationFn: chatService.sendMessage,
    onSuccess: (data, variables) => {
      // El servicio ya invalida el cache automáticamente
      // No invalidamos queries adicionales aquí para evitar invalidaciones duplicadas
      // useChatMessages maneja la actualización vía realtime con debouncedInvalidate
      if (DEBUG) console.log('[CACHE] useSendMessage: Mensaje enviado exitosamente (invalidación manejada por servicio y realtime)');

      // Aquí se podría agregar lógica para notificaciones push,
      // usando megaNotificador con TCA del destinatario.
    },
    onError: (error) => {
      // Manejo de errores: mostrar toast o loggear.
      if (DEBUG) console.error('Error al enviar mensaje:', error);
    },
  });
}
